import React, { ChangeEvent, useCallback, useState } from 'react';

import { Box, Button, Stack, TextField } from '@mui/material';

import InputCruiseLineSelect from '~/components/Cruises/components/Selects/InputCruiseLineSelect';
import { DealCrawlerFilters } from '~/components/Cruises/context/useCruiseDealsCrawler';

import { CruiseLine } from '~/services/cruises/CruiseLineService';

type Props = {
  isLoading: boolean;
  filters: DealCrawlerFilters;
  onSearch: (filters: DealCrawlerFilters) => void;
};

export default function DealCrawlerSearchForm({ isLoading, filters, onSearch }: Props) {
  const [localFilters, setLocalFilters] = useState<DealCrawlerFilters>(filters);

  const handleChangeField = useCallback((event: ChangeEvent<HTMLInputElement>) => {
    if (event?.target?.name) {
      setLocalFilters((prev) => ({
        ...prev,
        [event.target.name]: event.target.value,
      }));
    }
  }, []);

  const handleCruiseLineField = useCallback((cruiseLine: CruiseLine) => {
    setLocalFilters((prev) => ({
      ...prev,
      vendorId: cruiseLine?.id,
    }));
  }, []);

  const handleSearch = useCallback(() => {
    onSearch({
      sourceUrl: localFilters.sourceUrl || undefined,
      vendorId: localFilters.vendorId || undefined,
    });
  }, [localFilters, onSearch]);

  return (
    <Stack direction="column" spacing={2} border={1} borderColor="divider" borderRadius={1} p={2}>
      <Stack direction="row" spacing={2}>
        <Box flexGrow={2}>
          <TextField
            fullWidth
            name="sourceUrl"
            label="Source URL"
            onChange={handleChangeField}
            value={localFilters.sourceUrl || ''}
          />
        </Box>
        <Box flexGrow={2}>
          <InputCruiseLineSelect
            label="Cruise line"
            value={localFilters.vendorId}
            onChange={handleCruiseLineField}
            allowEmpty
            withApprovedOffers
          />
        </Box>
        <Box alignSelf="center">
          <Button variant="contained" disabled={isLoading} onClick={handleSearch}>
            Search
          </Button>
        </Box>
      </Stack>
    </Stack>
  );
}
